<template>
  <div class="barNotificatios">
    <div class="NumberNotifications">
      <p class="NumberNotifications__p"><strong>3 New Notificatios</strong></p>
    </div>
    <div class="notificatios">
      <div class="notificatios__time">
        <span>A second ago</span>
        <font-awesome-icon class="borrar" icon="times" @click="close" />
      </div>
      <div class="notificatios__content">
        <p>You just scheduled a meeting with Martin Essenfeld</p>
      </div>
      <div class="notificatios__button">
        <button @click="link">Link</button>
      </div>
    </div>
    <div class="notificatios">
      <div class="notificatios__time">
        <span>One hour ago</span>
        <font-awesome-icon class="borrar" icon="times" @click="close" />
      </div>
      <div class="notificatios__content">
        <p>
          The consultant Martin Essenfeld has uploaded a deliverable with the
          name
          <strong>Final Results</strong>
        </p>
      </div>
    </div>
    <div class="notificatios">
      <div class="notificatios__time">
        <span>Two hours ago</span>
        <font-awesome-icon class="borrar" icon="times" @click="close" />
      </div>
      <div class="notificatios__content">
        <p>You have modified the time of your meeting scheduled for today</p>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  methods: {
    link() {
      window.open("https://meet.google.com/fop-czay-rvo");
    },
    close() {
      this.$emit("cerrar", false);
    },
  },
};
</script>
<style lang="css" scoped>
.barNotificatios {
  position: absolute;
  top: 110%;
  left: -315px;
  display: flex;
  flex-direction: column;
  background: white;
  box-shadow: 0px 0px 15px 1px var(--twelveth-color);
  width: 350px;
  text-align: justify;
  font-family: PTSans, sans-serif;
  font-weight: 400;
  font-size: 17px;
}
.NumberNotifications {
  background: #fafafa;
  width: 100%;
}
.NumberNotifications__p {
  margin: 10px;
}
.notificatios {
  display: flex;
  flex-direction: column;
  background: white;
  border-bottom: 2px solid #f5f5f5;
  margin: 10px;
  color: #727272;
}
.notificatios__time {
  margin: 5px;
  font-size: 13px;
}
.notificatios__content {
  margin: 5px;
}
.notificatios__button {
  width: 100%;
  display: flex;
  justify-content: flex-end;
}
.notificatios__button button {
  background: var(--firts-color);
  width: 60px;
  text-align: center;
  border-radius: 5px;
  color: #fff;
  margin-top: -20px;
  margin-bottom: 5px;
  margin-right: 15px;
  font-family: PTSans, sans-serif;
  font-weight: bold;
  font-size: 18px;
}
.borrar {
  position: absolute;
  right: 20px;
}
@media (max-width: 431px) {
  .barNotificatios {
    position: absolute;
    top: 110%;
    left: -250px;
    width: 300px;
  }
}
@media (max-width: 344px) {
  .barNotificatios {
    position: absolute;
    top: 110%;
    left: -230px;
    width: 300px;
  }
}
</style>